import TagManager from 'react-gtm-module';
import Config from '../config/Config';

export const tagEvent = (tagdata) => {
    console.log('%c event data', 'color: yellow; background-color: black;', tagdata)
    console.log('%c  tagged event', 'color: yellow; background-color: black;', tagdata['event'])
    const tagManagerArgs = {
        gtmId: Config.GTM_TAG,
        dataLayer: tagdata
    }
    //TagManager.initialize(tagManagerArgs);
}